import { Pipe, PipeTransform } from 'angular-ts-decorators';
import { FilterOption } from '../../models';

@Pipe({
  name: 'onlyVisibleOptions',
})
export class OnlyVisibleOptionsPipe implements PipeTransform {
  public transform(options: FilterOption[]) {
    return options.filter((o: FilterOption) => o.visible);
  }
}
